<div class="app">
  <app-navbar></app-navbar>
  <div class="imagery">
    <app-imagery-change-map></app-imagery-change-map>
    <div>
      <ansyn-imagery-view [settings]="settings"></ansyn-imagery-view>
      <ansyn-annotations-context-menu [mapId]="settings.id"></ansyn-annotations-context-menu>
    </div>
  </div>

  <app-annotations-control></app-annotations-control>

</div>
